import useSearch from "./useSearch";

export default useSearch;
